var _path, _path2, _path3, _g, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoBlack = function SvgLogoBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 136,
    height: 30,
    fill: "none",
    viewBox: "0 0 136 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    fillRule: "evenodd",
    d: "M0 7.882v21.98h4.724V16.298l5.83 8.854h2.743l4.32-6.539.908-1.373-2.441-4.213-.908 1.377-3.235 4.909-7.563-11.43zM62.564 11.985h-3.52v13.722h3.52c4.369 0 6.726-2.33 6.726-6.862s-2.357-6.86-6.726-6.86m0-4.155c7.827 0 11.536 4.626 11.536 11.015s-3.71 11.016-11.536 11.016h-8.236V7.83zM84.808 7.83c2.508 0 5.047.606 6.86 1.634v4.237c-1.783-1.271-4.17-1.906-6.528-1.876-2.297.03-3.446.665-3.446 1.967 0 3.661 11.576 2.3 11.576 9.835 0 4.751-3.808 6.234-8.251 6.234-2.932 0-5.652-.696-7.828-1.907v-4.328a13.54 13.54 0 0 0 7.496 2.24c2.448 0 3.959-.514 3.959-2.028 0-3.964-11.576-2.48-11.576-9.986 0-4.085 3.567-6.022 7.738-6.022M112.324 7.83v4.155h-10.781v4.689h9.839v4.123h-9.839v4.91h10.97v4.154H96.828V7.83zM116.328 29.86V7.83h4.432l10.247 14.383a47 47 0 0 1-.094-3.021V7.83h4.715v22.03h-4.432l-10.247-14.382c.063.913.094 2.014.094 3.021v11.362zM40.389 11.87a2.1 2.1 0 0 0-.279-1.185l-1.646-2.853h-1.698l2.068 3.587c.08.14.106.301.074.452z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    fillRule: "evenodd",
    d: "m51.186 19.846-5.2 9.014a1.99 1.99 0 0 1-1.727 1.002h-10.4a1.99 1.99 0 0 1-1.728-1.002L29.04 23.5l-.851-1.473-1.258-2.181a2.01 2.01 0 0 1 0-2.001l5.2-9.014a1.99 1.99 0 0 1 1.727-1h2.908l2.069 3.588c.08.14.106.301.073.452h-3.873l-4.023 6.976 1.827 3.165.748 1.3 1.448 2.512h8.046l4.023-6.977-4.023-6.976H40.39a2.1 2.1 0 0 0-.28-1.186l-1.646-2.853h5.794a1.99 1.99 0 0 1 1.728.999l5.2 9.014c.355.62.355 1.38 0 2",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "logo-black_svg__mask0_14051_15910",
    width: 28,
    height: 24,
    x: 13,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M13.953 0h26.442v23.5H13.953z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#logo-black_svg__mask0_14051_15910)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F17900",
    fillRule: "evenodd",
    d: "M23.786 22.027v1.472h5.255l-.851-1.472zm16.326-11.342-1.647-2.853-3.902-6.767A2.13 2.13 0 0 0 32.72 0h-11.09c-.763 0-1.463.407-1.844 1.065l-5.549 9.62a2.14 2.14 0 0 0 0 2.13l.895 1.552 2.435 4.22 1.507 2.614v-2.945l-.601-1.047-2.435-4.222-.524-.907a.66.66 0 0 1 0-.66l5.544-9.617a.66.66 0 0 1 .572-.33h11.09c.235 0 .455.124.572.33l3.477 6.029 2.068 3.587c.08.14.106.301.073.452a.6.6 0 0 1-.073.209l-5.545 9.616a.64.64 0 0 1-.451.316l.748 1.3a2.13 2.13 0 0 0 .975-.878l5.55-9.62a2.1 2.1 0 0 0 .278-.943 2.1 2.1 0 0 0-.279-1.186",
    clipRule: "evenodd"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#2C3144",
    fillRule: "evenodd",
    d: "M23.788 7.832v22.03h-4.713V16.295l-.601.915-2.435-4.223 3.381-5.155z",
    clipRule: "evenodd"
  })));
};
export default SvgLogoBlack;